<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'h5',
};
</script>
<style lang="scss">
@import "../src/style/common/font.css";
// @import "~jsoneditor/dist/jsoneditor.css";
</style>

